<template>
  <div class="card">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="周历" name="first">
        <week-calendar :calendar-data="wcalendarData"></week-calendar>
        <e-calendar :calendar-data="ecalendarData" @sign-up="signupExplain(arguments)"></e-calendar>
      </el-tab-pane>
      <el-tab-pane label="日历" name="second">
        <el-select v-model="venue" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <day-calendar :calendar-data="dcalendarData"></day-calendar>
      </el-tab-pane>
    </el-tabs> -->
    <el-button type="primary" @click="exportCalendar" v-if="userMess.applyPost==2">导出</el-button>
    <week-calendar :calendar-data="wcalendarData" @change-date="getData" ref="calendar"></week-calendar>
  </div>
</template>

<script>
// day - calendar.vue
// import eSignup from '@/components/modal/signup-explain.vue'
// import sSignup from '@/components/modal/signup-service.vue'
import weekCalendar from './components/calendar/week-calendar.vue'
// import sCalendar from './components/calendar/scalendar.vue'
// import list from './components/list/list.vue'
export default {
  components: {
    weekCalendar
  },
  data() {
    return {
      wcalendarData: {},
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user.user
    },
  },
  watch: {},
  methods: {
    getData(val) {
      // console.log(val)
      let startTime = val.split(",")[0]
      let endTime = val.split(",")[1]
      // console.log(startTime, endTime)
      let params = {
        startTime: startTime,
        endTime: endTime
      }
      this.$api.getWebServiceSchedule(params).then(res => {
        // console.log(res.data)
        this.wcalendarData = res.data
      })
    },
    //导出
    exportCalendar() {
      let time = this.$refs.calendar.dateFormat.split(",")
      window.open(this.$api.exportWebServiceSchedules + '?startTime=' + time[0] + '&endTime=' + time[1])
      // this.$api.exportWebServiceSchedule({ startTime: time[0], endTime: time[1] }).then(res => {
      //   console.log(res)
      //   if (res.status == 200) {
      //     const contentDisposition = res.headers['content-disposition'];
      //     const filename = decodeURI(contentDisposition.split('fileName=')[1] || contentDisposition.split('filename=')[1]);
      //     const blob = new Blob([res.data]);
      //     const url = window.URL.createObjectURL(blob);
      //     if (window.navigator.msSaveBlob) {
      //       try {
      //         window.navigator.msSaveBlob(blob, filename);
      //       }
      //       catch (e) {
      //         console.log(e);
      //       }
      //     }
      //     else {
      //       let link = document.createElement('a');
      //       link.style.display = 'none';
      //       link.href = url;
      //       link.setAttribute('download', filename);
      //       document.body.appendChild(link);
      //       link.click();
      //     }
      //   }
      // })
    }

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.getData()
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
</style>
